import { Navigate, Route } from 'react-router-dom';

import AppLayout from '@/components/layout/AppLayout';
import { adminRoutes } from '@/routes/admin.routes';
import { clientRoutes } from '@/routes/client.routes';
import AuthGuard from '@/routes/guards/auth-guard';
import { publicRoutes } from '@/routes/public.routes';
import RootLayout from '@/routes/root-layout';
import { paths } from '@/shared/routes/paths';

/**
 * The full route tree, kept in its own module so it can be both turned into a
 * router config (see router.ts) and walked by tests (see route-coverage.test)
 * without tripping react-refresh's "components only" rule. Zones live in their
 * own `*.routes.tsx` files and are inlined here as JSX fragments; React Router
 * flattens fragments when building the route config.
 *
 * Shell: RootLayout (error boundary + Suspense) → public routes, and the
 * protected block AuthGuard → AppLayout → client routes + the self-guarded
 * admin routes.
 */
export const routeTree = (
  <Route element={<RootLayout />}>
    {publicRoutes}
    <Route element={<AuthGuard />}>
      <Route element={<AppLayout />}>
        {clientRoutes}
        {adminRoutes}
      </Route>
    </Route>
    {/* Catch-all redirect */}
    <Route path="*" element={<Navigate to={paths.home} replace />} />
  </Route>
);
